import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchPatientVisitOverview = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");

  const URL = `${__API_URL__}/api/photos/patients/${patientId}/trials/${trialId}/visit-overview/`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetPatientVisitOverview = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_overview", trialId, patientId],
    queryFn: () => fetchPatientVisitOverview({ patientId, trialId }),
    enabled: enabled && Boolean(patientId && trialId),
  });
};

export default useGetPatientVisitOverview;
